import { Text } from '@radix-ui/themes';
import { CommonDialog } from 'components/common/dialogs';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { SpecialMsPosition } from 'lib_ts/interfaces/machine-msg/i-special-mstarget';
import { useContext, useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';

interface IProps {
  key: number;
  allowLowering?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

// wait for a max of 20s to lower
// const LOWERING_TIMEOUT_MS = 20000;
const LOWERING_TIMEOUT_MS = 8000;

export const VisionLowerMachineConfirmation = (props: IProps) => {
  const { specialMsTarget } = useContext(MachineContext);
  const [lowering, setLowering] = useState(false);
  const loweringTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onLowered = () => {
    console.log('** on lowered');
    setLowering(false);
    props.onConfirm();
    props.onClose();

    if (loweringTimeoutRef.current) {
      clearTimeout(loweringTimeoutRef.current);
    }
  };

  const onContinue = () => {
    if (!props.allowLowering) {
      onLowered();
      return;
    }

    specialMsTarget(SpecialMsPosition.home);

    setLowering(true);
    loweringTimeoutRef.current = setTimeout(() => {
      console.log('** lowering timeout reached');
      onLowered();
    }, LOWERING_TIMEOUT_MS);
  };

  /* useEffect(() => {
    const callback = (event: CustomEvent) => {
      const data: IMachineStateMsg = event.detail;

      console.log('*** VisionLowerMachineConfirmation - MsCurrent:', data);
      if (data.px !== 0) {
        return;
      }

      onLowered();
    };

    WebSocketHelper.on(WsMsgType.M2U_MsCurrent, callback);

    return () => {
      WebSocketHelper.remove(WsMsgType.M2U_MsCurrent, callback);

      if (loweringTimeoutRef.current) {
        clearTimeout(loweringTimeoutRef.current);
      }
    };
  }, []); */

  useEffect(() => {
    return () => {
      if (loweringTimeoutRef.current) {
        clearTimeout(loweringTimeoutRef.current);
      }
    };
  }, []);

  const userCopy = t('settings.trajekt-vision-lower-machine-warning');
  const adminCopy =
    'Please ask the operator to lower the machine before starting calibration, to ensure accurate tracking and safe operation.\n\n **If the operator is not available and it is safe to do so, impersonate the user and click Lower.**';

  return (
    <CommonDialog
      key={props.key}
      maxWidth={RADIX.DIALOG.WIDTH.SM}
      identifier="VisionLowerMachineConfirmation"
      // title="common.lower-machine"
      title={
        props.allowLowering
          ? t('common.lower-machine')
          : 'Confirm Machine is Lowered'
      }
      content={
        <Text>
          <ReactMarkdown
            children={props.allowLowering ? userCopy : adminCopy}
          />
        </Text>
      }
      buttons={[
        {
          label: 'common.cancel',
          color: RADIX.COLOR.NEUTRAL,
          loading: lowering,
          disabled: lowering,
          onClick: props.onClose,
        },
        {
          label: props.allowLowering ? 'Lower & Continue' : 'Confirm',
          color: props.allowLowering
            ? RADIX.COLOR.WARNING
            : RADIX.COLOR.SUCCESS,
          variant: 'solid',
          disabled: lowering,
          loading: lowering,
          onClick: onContinue,
        },
      ]}
      width={RADIX.DIALOG.WIDTH.MD}
      onClose={props.onClose}
    />
  );
};
